import React from "react";
import { Box } from "@mui/material";
import { CreateButton } from "@refinedev/mui";

import { DataGrid } from "@shared/components/DataGrid";
import { FilterDropdown } from "@shared/components";
import {
  CreateIntegrationModal,
  EditIntegrationModal,
  IntegrationListFilters,
} from "@modules/erpIntegrations/components";

import { useCatalogTab } from "./controller";
import { useCatalogColumns } from "./columns";

export const CatalogTab = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    createModalRef,
    editModalRef,
    refetch,
    translate,
  } = useCatalogTab();

  const columns = useCatalogColumns(translate, editModalRef, refetch);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1 }}>
        <FilterDropdown paramPrefix="catalog_" initialValues={{ search: "" }}>
          <IntegrationListFilters />
        </FilterDropdown>
        <CreateButton onClick={() => createModalRef.current?.open()} />
      </Box>

      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        sortingOrder={["asc", "desc"]}
      />

      <CreateIntegrationModal
        onComplete={() => refetch()}
        modalRef={createModalRef}
      />
      <EditIntegrationModal
        onComplete={() => refetch()}
        modalRef={editModalRef}
      />
    </>
  );
});
